import { combineReducers } from 'redux';

import events from './eventsCompose';
import * as fromEvents from './eventsCompose';
import users from './usersCompose';
import * as fromUsers from './usersCompose';
import revenue from './revenueCompose';
import * as fromRevenue from './revenueCompose';
import retentionComplex from './complexRetentionCompose';
import * as fromRetentionComplex from './complexRetentionCompose';
import retention from './retentionCompose';
import * as fromRetention from './retentionCompose';
import funnels from './funnels';
import * as fromFunnels from './funnels';

export default combineReducers({
  events,
  users,
  retention,
  retentionComplex,
  revenue,
  funnels,
});

export const getIds = (state) => fromEvents.getIds(state.events);

export const getGroupColumn = (state) => fromEvents.getGroupColumn(state.events);

export const getSql = (state, id) => fromEvents.getSql(state.events, id);

export const getError = (state, id) => fromEvents.getError(state.events, id);

export const getName = (state, id) => fromEvents.getName(state.events, id);

export const getUniqueChar = (state, id) => fromEvents.getUniqueChar(state.events, id);

export const getPeriodsState = (state, id) => fromEvents.getPeriodsState(state.events, id);

export const getFilter = (state, id) => fromEvents.getFilter(state.events, id);

export const getAggregationColumn = (state, id) =>
  fromEvents.getAggregationColumn(state.events, id);

export const getAggregationType = (state, id) => fromEvents.getAggregationType(state.events, id);

export const getSplitColumn = (state, id) => fromEvents.getSplitColumn(state.events, id);

export const getEvents = (state) => fromEvents.getEvents(state.events);

export const getIdUsingTemplate = (state) => fromEvents.getIdUsingTemplate(state.events);

export const getEventsCsv = (state) => fromEvents.getCsv(state.events);

export const getOthersFilter = (state, id) => fromEvents.getOthersFilter(state.events, id);

export const getEventView = (state) => fromEvents.getEventView(state.events);

export const getEnteredFormula = (state) => fromEvents.getEnteredFormula(state.events);

export const getEnteredLegendName = (state) => fromEvents.getEnteredLegendName(state.events);

export const getIsFormulaOnly = (state) => fromEvents.getIsFormulaOnly(state.events);

export const getEventOptions = (state) => fromEvents.getEventOptions(state.events);

export const getDashboardRetentionSimpleFirstEvent = (state) =>
  fromRetention.getFirstEvent(state.retention);

export const getDashboardRetentionSimpleReturnEvent = (state) =>
  fromRetention.getReturnEvent(state.retention);

export const getDashboardRetentionSimpleDimensionType = (state) =>
  fromRetention.getDimensionType(state.retention);

export const getDashboardRetentionSimpleOptions = (state) =>
  fromRetention.getRetentionSimpleOptions(state.retention);

export const getFirstEvent = (state) => fromRetentionComplex.getFirstEvent(state.retentionComplex);

export const getFirstEventFilter = (state) =>
  fromRetentionComplex.getFirstEventFilter(state.retentionComplex);

export const getReturnEvent = (state) =>
  fromRetentionComplex.getReturnEvent(state.retentionComplex);

export const getReturnEventFilter = (state) =>
  fromRetentionComplex.getReturnEventFilter(state.retentionComplex);

export const getUseLatestProfile = (state) =>
  fromRetentionComplex.getUseLatestProfile(state.retentionComplex);

export const getDimensionType = (state) =>
  fromRetentionComplex.getDimensionType(state.retentionComplex);

export const getFilterFor = (state, eventIndex) =>
  fromRetentionComplex.getFilterFor(state.retentionComplex, eventIndex);

export const isCustomSequenceEnabled = (state) =>
  fromRetentionComplex.isCustomSequenceEnabled(state.retentionComplex);

export const getCustomSequenceType = (state) =>
  fromRetentionComplex.getCustomSequenceType(state.retentionComplex);

export const getCustomSequence = (state) =>
  fromRetentionComplex.getCustomSequence(state.retentionComplex);

export const getCustomSequenceDimensions = (state) =>
  fromRetentionComplex.getCustomSequenceDimensions(state.retentionComplex);

export const getRetentionIdUsingTemplate = (state) =>
  fromRetentionComplex.getIdUsingTemplate(state.retentionComplex);

export const getRetentionComplexSQL = (state) =>
  fromRetentionComplex.getRetentionComplexSQL(state.retentionComplex);

export const getRetentionError = (state) => fromRetentionComplex.getError(state.retentionComplex);

export const getRetentionComplexOptions = (state) =>
  fromRetentionComplex.getRetentionComplexOptions(state.retentionComplex);

export const getEvent = (state) => fromUsers.getEvent(state.users);

export const getColumns = (state) => fromUsers.getColumns(state.users);

export const isAggregateEnabled = (state) => fromUsers.isAggregateEnabled(state.users);

export const getUserFilter = (state) => fromUsers.getUserFilter(state.users);

export const getIdUsingUsersTemplate = (state) => fromUsers.getIdUsingTemplate(state.users);

export const getUsersSQL = (state) => fromUsers.getUsersSQL(state.users);

export const getUsersError = (state) => fromUsers.getError(state.users);

export const getAmountField = (state) => fromRevenue.getAmountField(state.revenue);

export const getAmountFields = (state) => fromRevenue.getAmountFields(state.revenue);

export const getRevenueGroupColumn = (state) => fromRevenue.getGroupColumn(state.revenue);

export const getRevenueSplitColumn = (state) => fromRevenue.getSplitColumn(state.revenue);

export const getQueryType = (state) => fromRevenue.getQueryType(state.revenue);

export const getPaymentFilter = (state) => fromRevenue.getPaymentFilter(state.revenue);

export const getOptions = (state) => fromRevenue.getOptions(state.revenue);

export const isUpdating = (state) => fromFunnels.isUpdating(state.funnels);

export const getUpdating = (state) => fromFunnels.getUpdating(state.funnels);

export const getUpdatingId = (state) => fromFunnels.getUpdatingId(state.funnels);

export const getFunnelConversionInterval = (state) =>
  fromFunnels.getFunnelConversionInterval(state.funnels);

export const getFunnelView = (state) => fromFunnels.getFunnelView(state.funnels);
